import { useState } from 'react';
import { useDidMount } from './useDidMount';

export const useScrolling = (): boolean => {
  const [scrolling, setScrolling] = useState(false);

  const onScroll = () => {
    const currentPosition = window.pageYOffset; // or use document.documentElement.scrollTop;
    setScrolling(currentPosition > 1);
  };

  useDidMount(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  });

  return scrolling;
};
